import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppConfig } from 'src/app/app-config.service';

@Component({
  selector: 'password-dialog',
  templateUrl: './password-dialog.component.html',
})
export class PasswordDialog {
  public password: string | null = null;

  constructor(
    private dialogRef: MatDialogRef<PasswordDialog>,
  ) { }

  checkPassword() {
    this.dialogRef.close(this.password == 'mppz');
  }
}
